import { render, staticRenderFns } from "./InfoCobranzasReportTable.vue?vue&type=template&id=edd15e92&scoped=true"
import script from "./InfoCobranzasReportTable.vue?vue&type=script&lang=js"
export * from "./InfoCobranzasReportTable.vue?vue&type=script&lang=js"
import style0 from "./InfoCobranzasReportTable.vue?vue&type=style&index=0&id=edd15e92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd15e92",
  null
  
)

export default component.exports